"use strict";

/*;
              	@submodule-license:
              		The MIT License (MIT)
              		@mit-license
              
              		Copyright (@c) 2017 Richeve Siodina Bebedor
              		@email: richeve.bebedor@gmail.com
              
              		Permission is hereby granted, free of charge, to any person obtaining a copy
              		of this software and associated documentation files (the "Software"), to deal
              		in the Software without restriction, including without limitation the rights
              		to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
              		copies of the Software, and to permit persons to whom the Software is
              		furnished to do so, subject to the following conditions:
              
              		The above copyright notice and this permission notice shall be included in all
              		copies or substantial portions of the Software.
              
              		THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
              		IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
              		FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
              		AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
              		LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
              		OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
              		SOFTWARE.
              	@end-submodule-license
              
              	@submodule-configuration:
              		{
              			"package": "heredito",
              			"path": "heredito/connect.js",
              			"file": "connect.js",
              			"module": "heredito",
              			"author": "Richeve S. Bebedor",
              			"contributors": [
              				"John Lenon Maghanoy <johnlenonmaghanoy@gmail.com>"
              			],
              			"eMail": "richeve.bebedor@gmail.com",
              			"repository": "https://github.com/volkovasystems/heredito.git",
              			"test": "heredito-test.js",
              			"global": false,
              			"internal": true
              		}
              	@end-submodule-configuration
              
              	@submodule-documentation:
              		Connector class factory.
              	@end-submodule-documentation
              
              	@include:
              		{
              			"clazof": "clazof",
              			"diatom": "diatom",
              			"een": "een",
              			"falzy": "falzy",
              			"kein": "kein",
              			"meton": "meton",
              			"posp": "posp",
              			"protype": "protype",
              			"statis": "statis",
              			"transpher": "transpher",
              			"truly": "truly"
              		}
              	@end-include
              */var _symbol = require("babel-runtime/core-js/symbol");var _symbol2 = _interopRequireDefault(_symbol);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var clazof = require("clazof");
var diatom = require("diatom");
var een = require("een");
var falzy = require("falzy");
var kein = require("kein");
var meton = require("meton");
var posp = require("posp");
var protype = require("protype");
var statis = require("statis");
var transpher = require("transpher");
var truly = require("truly");

var INHERITANCE = (0, _symbol2.default)("inheritance");
var CHILD = (0, _symbol2.default)("child");

var connect = function connect() {
	var Connector = diatom("Connector");

	statis(Connector).

	attach(INHERITANCE, []).

	implement("flush", function flush() {
		while (this[INHERITANCE].length) {
			this[INHERITANCE].pop();
		}

		return this;
	}).

	implement("reset", function reset() {var _this = this;
		posp(meton(this.prototype), "constructor").
		forEach(function (method) {return delete _this.prototype[method];});

		this.flush();

		delete this[CHILD];

		return this;
	}).

	implement("push", function push(parent) {
		/*;
                                          	@meta-configuration:
                                          		{
                                          			"parent:required": "function"
                                          		}
                                          	@end-meta-configuration
                                          */

		if (falzy(parent) || !protype(parent, FUNCTION)) {
			throw new Error("invalid parent class");
		}

		/*;
    	@note:
    		Accumulate parent to the connector.
    	@end-note
    */
		do {
			if (!een(this[INHERITANCE], parent)) {
				this[INHERITANCE].push(parent);
			}

		} while (truly(parent = parent.prototype.parent));

		return this;
	}).

	implement("trace", function trace(parent) {var _this2 = this;
		/*;
                                                               	@meta-configuration:
                                                               		{
                                                               			"parent:required": "function"
                                                               		}
                                                               	@end-meta-configuration
                                                               */

		if (falzy(parent) || !protype(parent, FUNCTION)) {
			throw new Error("invalid parent class");
		}

		if (kein("connector", parent) && clazof(parent.connector, "Connector")) {
			parent.connector[INHERITANCE].forEach(function (ancestor) {return _this2.push(ancestor);});
		}

		return this;
	}).

	implement("register", function register(child) {
		/*;
                                                 	@meta-configuration:
                                                 		{
                                                 			"child:required": "function"
                                                 		}
                                                 	@end-meta-configuration
                                                 */

		if (falzy(child) || !protype(child, FUNCTION)) {
			throw new Error("invalid child class");
		}

		transpher(this, child, true);

		this[CHILD] = child;

		return this;
	});

	return Connector;
};

module.exports = connect;

//# sourceMappingURL=connect.js.map


//////////////////
// WEBPACK FOOTER
// ./bower_components/heredito/connect.js
// module id = 266
// module chunks = 0